// AdminDashboard.js — tabbed admin shell (Metrics | Users | Caller-ID Requests | Improvement Requests).
// Mounted at /admin; access control enforced upstream by PrivateRoute requireAdmin.

import React, { useState } from 'react';
import { Box, Tabs, Tab, Button, Badge } from '@mui/material';
import usePendingProposalCount from '../../hooks/usePendingProposalCount';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import MetricsTab from './MetricsTab';
import UsersTab from './UsersTab';
import AdminCallerIdRequests from './AdminCallerIdRequests';
import AdminImprovementRequests from './AdminImprovementRequests';

const AdminDashboard = () => {
  const [tab, setTab] = useState(0);
  const navigate = useNavigate();
  const pendingCount = usePendingProposalCount();

  // Uniform tab dimensions: enough width for "Improvement" / "Improvement"
  // wrapping (~12 character payload) PLUS room on the right for the
  // badge dot to land fully inside the Tab without clipping. Two-line
  // capacity, text bottom-aligned so single-line labels (Metrics, Users)
  // sit on the same baseline as the bottom line of two-line labels.
  const tabSx = {
    width: '150px',
    minWidth: '150px',
    whiteSpace: 'normal',
    justifyContent: 'flex-end',
    paddingTop: '12px',
    paddingBottom: '8px',
    lineHeight: 1.2,
    overflow: 'visible',
  };

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <h2 style={{ margin: 0 }}>Admin Dashboard</h2>
        <Button
          startIcon={<ArrowBackIcon />}
          variant="outlined"
          onClick={() => navigate('/')}
        >
          Back to Maia
        </Button>
      </Box>
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        sx={{
          mb: 2,
          overflow: 'visible',
          '& .MuiTabs-scroller': { overflow: 'visible !important' },
          '& .MuiTabs-flexContainer': { overflow: 'visible' },
        }}
      >
        <Tab sx={tabSx} label="Metrics" />
        <Tab sx={tabSx} label="Users" />
        <Tab sx={tabSx} label="Caller-ID Requests" />
        <Tab sx={tabSx} label={
          <Badge
            badgeContent={pendingCount}
            color="error"
            invisible={pendingCount === 0}
            sx={{ '& .MuiBadge-badge': { right: -16, top: -2 } }}
          >
            Improvement Requests
          </Badge>
        } />
      </Tabs>
      {tab === 0 && <MetricsTab />}
      {tab === 1 && <UsersTab />}
      {tab === 2 && <AdminCallerIdRequests />}
      {tab === 3 && <AdminImprovementRequests />}
    </Box>
  );
};

export default AdminDashboard;
